import React, { useState } from 'react';
import type { FC } from 'react';
import { fields, match, variant } from 'variant';
import type { VariantOf } from 'variant';
import { DashboardArrowViewer } from './DashboardArrowViewer.js';
import { DashboardNumericViewer } from './DashboardNumericViewer.js';
import type { DevCenterComponent } from '../../dev-center/components/dev-center-component.js';
import type { DashboardExtension } from '../extensions/useExtensions.js';

export const DashboardScreenSelector = variant({
  Arrow: fields<{
    dashboardExtension: DashboardExtension;
  }>(),
  Numeric: {},
});

export type DashboardScreenSelector = VariantOf<typeof DashboardScreenSelector>;

interface Props {
  onClose: () => void;
  onSelect?: (page: DevCenterComponent<DashboardExtension>) => void;
  initialSelectorType?: DashboardScreenSelector;
}

export const DashboardScreen: FC<Props> = ({
  onClose,
  onSelect,
  initialSelectorType = DashboardScreenSelector.Numeric(),
}) => {
  const [selectorType, setSelectorType] =
    useState<DashboardScreenSelector>(initialSelectorType);

  return (
    <>
      {match(selectorType, {
        Arrow: ({ dashboardExtension }) => (
          <DashboardArrowViewer
            dashboardExtension={dashboardExtension}
            onSelect={onSelect}
            onClose={onClose}
          />
        ),
        Numeric: () => (
          <DashboardNumericViewer
            onViewMore={setSelectorType}
            onSelect={onSelect}
            onClose={onClose}
          />
        ),
      })}
    </>
  );
};
